import React from "react";
import {
  DollarSign,
  Rocket,
  Target,
  Calendar,
  TrendingUp,
  Award,
  Zap,
  Flag,
  Users,
  Building,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { DynamicIconProps } from "./DynamicIcon.types";

const DynamicIcon: React.FC<DynamicIconProps> = ({ 
  iconName, 
  fallbackIcon: FallbackIcon, 
  className, 
  color 
}) => {
  // Map of available icons - extend as needed
  const iconMap: Record<string, LucideIcon> = {
    DollarSign: DollarSign,
    Rocket: Rocket,
    Target: Target,
    Calendar: Calendar,
    TrendingUp: TrendingUp,
    Award: Award,
    Zap: Zap,
    Flag: Flag,
    Users: Users,
    Building: Building,
    // Add more icons as needed
  };

  const IconComponent =
    iconName && iconMap[iconName] ? iconMap[iconName] : FallbackIcon;

  return <IconComponent className={className} style={{ color }} />;
};

export default DynamicIcon;